(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-panels"] && !Shopify.designMode) return;
  try {
    

(function () {

  /* ── Desktop: :has() fallback ── */
  if (!CSS.supports('selector(:has(*))')) {
    document.querySelectorAll('.cp-grid').forEach(function (grid) {
      var panels = Array.prototype.slice.call(grid.querySelectorAll('.cp-panel'));
      panels.forEach(function (panel) {
        panel.addEventListener('mouseenter', function () {
          panels.forEach(function (p) {
            p.classList.toggle('is-hovered', p === panel);
            p.classList.toggle('is-sibling', p !== panel);
          });
        });
        panel.addEventListener('mouseleave', function () {
          panels.forEach(function (p) {
            p.classList.remove('is-hovered', 'is-sibling');
          });
        });
      });
    });
  }

  /* ── Mobile: dot sync via IntersectionObserver ── */
  function initSlider(section) {
    var grid   = section.querySelector('.cp-grid');
    var dots   = Array.prototype.slice.call(section.querySelectorAll('.cp-dot'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('.cp-panel'));

    if (!grid || !dots.length || !panels.length) return;

    /* Update dots to reflect which panel is most visible */
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio >= 0.5) {
          var idx = panels.indexOf(entry.target);
          dots.forEach(function (d, i) {
            d.classList.toggle('is-active', i === idx);
          });
        }
      });
    }, {
      root: grid,
      threshold: 0.5
    });

    panels.forEach(function (p) { observer.observe(p); });

    /* Dot click → scroll to that panel */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.getAttribute('data-index'), 10);
        var target = panels[idx];
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    });
  }

  /* Init on DOMContentLoaded and after Shopify section re-renders */
  function initAll() {
    document.querySelectorAll('.collection-panels').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Shopify theme editor live reload */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.collection-panels') || e.target;
    initSlider(section);
  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collectionpanel"] && !Shopify.designMode) return;
  try {
    

(function () {

  /* ── Desktop: :has() fallback ── */
  if (!CSS.supports('selector(:has(*))')) {
    document.querySelectorAll('.cp-grid').forEach(function (grid) {
      var panels = Array.prototype.slice.call(grid.querySelectorAll('.cp-panel'));
      panels.forEach(function (panel) {
        panel.addEventListener('mouseenter', function () {
          panels.forEach(function (p) {
            p.classList.toggle('is-hovered', p === panel);
            p.classList.toggle('is-sibling', p !== panel);
          });
        });
        panel.addEventListener('mouseleave', function () {
          panels.forEach(function (p) {
            p.classList.remove('is-hovered', 'is-sibling');
          });
        });
      });
    });
  }

  /* ── Mobile: dot sync via IntersectionObserver ── */
  function initSlider(section) {
    var grid   = section.querySelector('.cp-grid');
    var dots   = Array.prototype.slice.call(section.querySelectorAll('.cp-dot'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('.cp-panel'));

    if (!grid || !dots.length || !panels.length) return;

    /* Update dots to reflect which panel is most visible */
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio >= 0.5) {
          var idx = panels.indexOf(entry.target);
          dots.forEach(function (d, i) {
            d.classList.toggle('is-active', i === idx);
          });
        }
      });
    }, {
      root: grid,
      threshold: 0.5
    });

    panels.forEach(function (p) { observer.observe(p); });

    /* Dot click → scroll to that panel */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.getAttribute('data-index'), 10);
        var target = panels[idx];
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    });
  }

  /* Init on DOMContentLoaded and after Shopify section re-renders */
  function initAll() {
    document.querySelectorAll('.collection-panels').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Shopify theme editor live reload */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.collection-panels') || e.target;
    initSlider(section);
  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
